import React from 'react';
import styled, { useTheme } from 'styled-components';
import { useTranslation } from '@com/core/common/translations/i18n';
import Loader from '@com/core/common/components/Loader';
import { TTheme } from '@com/core/common/types/styles/theme';
import { THit } from '@com/core/common/types/catalog';
import ProductCarousel from '../common/ProductCarousel';

type TProps = {
    recommendedItems: THit[];
    isLoading: boolean;
    isRecommended?: boolean;
};

const Recommendations = ({ isLoading, isRecommended, recommendedItems }: TProps): JSX.Element | null => {
    const { t } = useTranslation('common');
    const theme = useTheme() as TTheme;

    return (
        <Container>
            {isLoading ? (
                <LoaderContainer>
                    <Loader size={10} color={theme.colors.brandPrimary} />
                </LoaderContainer>
            ) : (
                recommendedItems.length > 0 && (
                    <>
                        <div className="siteWidthContainer">
                            <Heading>
                                {isRecommended ? t('inspired-from-your-cart') : t('customers-also-viewed')}
                            </Heading>
                        </div>
                        <ProductCarousel
                            isRecommended={isRecommended}
                            eventLocation="recos_page-detail"
                            products={recommendedItems}
                        />
                    </>
                )
            )}
        </Container>
    );
};

const LoaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

const Container = styled.div`
    margin-top: 64px;
    padding-top: 52px;
    border-top: 1px solid ${({ theme }): string => theme.colors.borderLight};
`;

const Heading = styled.h3`
    font-weight: bold;
    font-size: 1.375rem;
    margin-bottom: 24px;
`;

export default Recommendations;
